<template>
  <div v-if="showLogin">
    <!-- Logged user / login -->
    <NuxtLink v-if="oidc.isLoggedIn" :to="getProfilePath()" class="avatar avatar--signed-in">
      <img
        v-if="oidcUserPicture"
        :src="oidcUserPicture"
        :alt="oidcUserName"
        :title="oidcUserName"
      />
      <span>{{ getInitials(oidcUserName) }}</span>
    </NuxtLink>
    <a
      v-else
      rel="nofollow"
      :class="{'loading': isLoginLoading}"
      @click="login()"
    >
      <DefaultIconsAccount class="account" />
    </a>
  </div>
</template>

<script setup lang="ts">
import {ref} from "vue";

const config = useRuntimeConfig()
const localePath = useLocalePath()
const oidc = useOidc()
const oidcUserPicture = oidc.user?.picture
const oidcUserName = oidc.user?.name
const isLoginLoading = ref(false)

const showLogin = config.public.showLogin || false

const getProfilePath = () => {
  return localePath({name: 'profile'})
}

const getInitials = (fullName: string) => {
  if (!fullName) {
    return 'CN'
  }
  const allNames = fullName.trim().split(' ');
  const initials = allNames.reduce((acc, curr, index) => {
    if(index === 0 || index === allNames.length - 1){
      acc = `${acc}${curr.charAt(0).toUpperCase()}`;
    }
    return acc;
  }, '');
  return initials;
}

const login = () => {
  if (isLoginLoading.value) {
    return
  }
  isLoginLoading.value = true
  oidc.login()
}
</script>